import { useRef, useState } from "react";
import { convertOrderStatusEnumToStatusCode } from "../../../utils/convertOrderStatusValue";
import { OrderStatusEnum } from "../../../enums/orderStatus";
import axios from "../../../lib/axios";
import { ADMIN_ORDER_UPDATE, ADMIN_ORDER_UPDATE_STATUS } from "../../../lib/endpoints/order";
import { OrderModel } from "../../../models/order";


interface Props {
    selectedData: OrderModel;
    onClose: VoidFunction;
    onRefetchData: () => Promise<void>;
  }

const useOrderReturnDetailController = ({selectedData,onClose,onRefetchData}:Props) => {
  const [openConfirmDialog, setOpenConfirmDialog] = useState<boolean>(false);
  const descriptionRef = useRef<HTMLInputElement>(null!);

  const [loadingConfirmDialog, setLoadingConfirmDialog] =
    useState<boolean>(false);

  const handleOpenConfirmDialog = () => {
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleReturnOrder=async ()=>{
    try {
        setLoadingConfirmDialog(true);
        const inputOrderStatus: number = convertOrderStatusEnumToStatusCode(OrderStatusEnum.Return);
        await axios.post(
          `${ADMIN_ORDER_UPDATE_STATUS}?orderId=${selectedData?.id}&status=${inputOrderStatus}&description=''`
        );
        await onRefetchData();
        onClose();
      } catch (err) {
        window.alert("server error please try again");
      } finally {
        setLoadingConfirmDialog(false);
      }
  }

  return {
    openConfirmDialog,
    handleOpenConfirmDialog,
    handleCloseConfirmDialog,
    loadingConfirmDialog,
    handleReturnOrder,
    descriptionRef
  };
};
export default useOrderReturnDetailController;
